// MfgGamesHome.jsx
// Hub page listing all 6 Manufacturing game categories and launching the selected game.

import React, { useState } from 'react';
import MfgAssemblyTycoon from './MfgAssemblyTycoon';
import LeanQuest from './LeanQuest';
import QualityChampions from './QualityChampions';
import MfgPuzzleMania from './MfgPuzzleMania';
import FactoryOlympics from './FactoryOlympics';
import MfgMetaverse from './MfgMetaverse';

// Categories
const categories = [
  { 
    id: 1, 
    title: 'Assembly Tycoon', 
    desc: 'Build and scale your own virtual factory, optimize supply chain, and maximize profits.', 
    component: <MfgAssemblyTycoon /> 
  },
  { 
    id: 2, 
    title: 'Lean Quest', 
    desc: 'Solve lean manufacturing challenges and eliminate waste in operations.', 
    component: <LeanQuest /> 
  },
  { 
    id: 3, 
    title: 'Quality Champions', 
    desc: 'Compete in quality control challenges with Six Sigma puzzles and defect reduction.', 
    component: <QualityChampions /> 
  },
  { 
    id: 4, 
    title: 'Mfg Puzzle Mania', 
    desc: 'Casual match-3 / logic puzzles with gears, tools, and parts themes.', 
    component: <MfgPuzzleMania /> 
  },
  { 
    id: 5, 
    title: 'Factory Olympics', 
    desc: 'Mini challenges like assembly line speed, robotic arms precision, packaging race.', 
    component: <FactoryOlympics /> 
  },
  { 
    id: 6, 
    title: 'Mfg Metaverse', 
    desc: 'Immersive digital twin factory hub for collaboration, design, and trading.', 
    component: <MfgMetaverse /> 
  },
];

export default function MfgGamesHome() {
  const [activeGame, setActiveGame] = useState(null);

  if (activeGame) {
    return (
      <div style={{padding:20}}>
        <button 
          onClick={() => setActiveGame(null)} 
          style={{marginBottom:12, padding:'6px 12px', borderRadius:8, border:'1px solid #ccc', cursor:'pointer'}}
        >
          ← Back to Games Home
        </button>
        {activeGame.component}
      </div>
    );
  }

  return (
    <div style={{padding:20, maxWidth:1000, margin:'0 auto'}}>
      <h1 className="text-3xl" style={{marginTop:0}}>🎮 Think5Whys SyntraMfg Games</h1>

      <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))', gap:16, marginTop:16}}>
        {categories.map(cat => (
          <div 
            key={cat.id} 
            style={{background:'#fff', borderRadius:12, padding:16, boxShadow:'0 4px 12px rgba(0,0,0,0.08)', display:'flex', flexDirection:'column', justifyContent:'space-between'}}
          >
            <h3 className="text-black text-2xl" style={{margin:'0 0 8px 0'}}>{cat.title}</h3>
            <p style={{flexGrow:1, fontSize:14, margin:'0 0 12px 0', color:'#444'}}>{cat.desc}</p>
            {cat.component ? (
              <button 
                onClick={() => setActiveGame(cat)} 
                style={{padding:'8px 12px', border:'none', borderRadius:8, background:'#1565c0', color:'#fff', cursor:'pointer'}}
              >
                ▶ Play
              </button>
            ) : (
              <button 
                disabled 
                style={{padding:'8px 12px', border:'none', borderRadius:8, background:'#ccc', color:'#666'}}
              >
                Coming Soon
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
